import { createAction, props } from '@ngrx/store';
import { AppLauncherInfo } from './appLauncher.model';

export const appLauncherSuccess = createAction(
  'Navigated to appLauncher Success',
  props<AppLauncherInfo>() 
);